import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image
} from "@react-pdf/renderer";

import HeaderImage from "./header.jpeg";
import FooterImage from "./footer.jpeg";
import PresupuestoPDF from "./PresupuestoPDF";
import { pdfStyles } from "./pdfStyles";

export default function CondicionesCuidador(props) {

  // ================================
  // TEXTOS DEL PDF DE CUIDADOR
  // ================================

  const alcances = [
    {
      bold: "Asistencia en actividades de la vida diaria (AVD): ",
      text: "Apoyo en la higiene personal, vestido, alimentación y movilidad dentro del hogar."
    },
    {
      bold: "Supervisión constante: ",
      text: "Atención las 24 horas, supervisando el bienestar físico y emocional del adulto mayor."
    },
    {
      bold: "Administración de medicación: ",
      text: "Supervisión en la toma de medicamentos según indicaciones médicas, siempre que no se trate de tareas que involucren procedimientos invasivos."
    },
    {
      bold: "Acompañamiento en citas médicas o actividades recreativas: ",
      text: "El cuidador podrá asistir a las citas médicas o acompañar al usuario a actividades recreativas según lo acordado."
    },
    {
      bold: "Monitoreo de signos vitales: ",
      text: "Toma de presión arterial, temperatura y otros signos básicos de salud, bajo la supervisión del personal médico."
    },
    {
      bold: "Comunicación con familiares: ",
      text: "Reporte diario o según lo solicitado sobre el estado del usuario, cambios o alertas de salud."
    }
  ];

  const limites1 = [
    {
      bold: "Intervenciones médicas: ",
      text: "El cuidador no está autorizado para realizar intervenciones médicas invasivas o procedimientos que requieran formación profesional en salud (por ejemplo, inyecciones, administración de sueros intravenosos, procedimientos quirúrgicos, etc.). Para estos casos, se recomienda el contacto con un profesional médico o de enfermería especializada."
    },
    {
      bold: "Atención en emergencias médicas: ",
      text: "En caso de emergencias médicas, el cuidador debe contactar inmediatamente a los servicios de emergencia (ambulancia) y a la familia, pero no es responsable de brindar atención de urgencia fuera de sus capacidades."
    },
    {
      bold: "Asistencia con movilidad compleja: ",
      text: "El servicio de acompañamiento no incluye el levantamiento o movilización de usuarios con condiciones de movilidad severa o que requieran equipos especiales de asistencia (por ejemplo, grúas para movilización)."
    }
  ];

  const limites2 = [
    {
      bold: "Responsabilidad por bienes personales: ",
      text: "El cuidador no es responsable de la seguridad de los bienes materiales del hogar o del usuario, salvo que esté directamente relacionado con el cuidado de la persona."
    },
    {
      bold: "Duración del servicio: ",
      text: "El servicio es limitado a las horas o días contratados y no incluye la cobertura fuera del horario pactado, como noches libres si el servicio no es de 24 horas continuas."
    }
  ];

  const condicionesAdicionales = [
    {
      bold: "Vacaciones o descansos: ",
      text: "En caso de que el cuidador necesite tomar vacaciones o descanso, se notificará con suficiente antelación y se garantizará la cobertura mediante un reemplazo de igual calificación."
    },
    {
      bold: "Confidencialidad: ",
      text: "El cuidador se compromete a mantener la confidencialidad de la información relacionada con el usuario y su familia."
    }
  ];

  // ================================
  // DOCUMENTO
  // ================================

  return (
    <Document>

      {/* ========================= PÁGINA 1 ========================= */}
      <Page size="A4" style={pdfStyles.page}>

        <Image src={HeaderImage} style={pdfStyles.headerImage} />
        <Image src={FooterImage} style={pdfStyles.footerImage} />

        <Text style={pdfStyles.mainTitle}>
          CONDICIONES DE SERVICIO - CUIDADOR DOMICILIARIO PARA ADULTOS MAYORES
        </Text>

        {/* 1. ALCANCES */}
        <Text style={pdfStyles.sectionTitle}>1. ALCANCES DEL SERVICIO</Text>

        {alcances.map((item, i) => (
          <View key={`a-${i}`} style={pdfStyles.bulletRow}>
            <Text style={pdfStyles.bulletPoint}>•</Text>
            <Text style={pdfStyles.bulletText}>
              <Text style={{ fontWeight: "bold" }}>{item.bold}</Text>
              {item.text}
            </Text>
          </View>
        ))}

        {/* 2. LÍMITES */}
        <Text style={pdfStyles.sectionTitle}>2. LÍMITES DEL SERVICIO</Text>

        {limites1.map((item, i) => (
          <View key={`l1-${i}`} style={pdfStyles.bulletRow}>
            <Text style={pdfStyles.bulletPoint}>•</Text>
            <Text style={pdfStyles.bulletText}>
              <Text style={{ fontWeight: "bold" }}>{item.bold}</Text>
              {item.text}
            </Text>
          </View>
        ))}

        {limites2.map((item, i) => (
          <View key={`l2-${i}`} style={pdfStyles.bulletRow}>
            <Text style={pdfStyles.bulletPoint}>•</Text>
            <Text style={pdfStyles.bulletText}>
              <Text style={{ fontWeight: "bold" }}>{item.bold}</Text>
              {item.text}
            </Text>
          </View>
        ))}

        <Text style={pdfStyles.italicParagraph}>
          Es importante señalar que el cuidador de adultos se enfoca principalmente en brindar atención y apoyo en aspectos relacionados con la salud y el bienestar de la persona a su cargo, como la asistencia en la movilidad, el seguimiento médico y el cuidado personal. Las tareas domésticas, como la limpieza o el mantenimiento del hogar, y elaboración de alimentos no forman parte de las tareas, por motivos de seguridad y bioseguridad del usuario, atendiendo a que el enfoque del cuidado al mismo no se disperse.
        </Text>

        <Text style={pdfStyles.firmaText}>
          Nombre y firma del cliente: ________________________________
        </Text>

      </Page>

      {/* ========================= PÁGINA 2 ========================= */}
      <Page size="A4" style={pdfStyles.page}>
        <Image src={HeaderImage} style={pdfStyles.headerImage} />
        <Image src={FooterImage} style={pdfStyles.footerImage} />

        {/* 3. ADICIONALES */}
        <Text style={pdfStyles.sectionTitle}>3. CONDICIONES ADICIONALES</Text>

        {condicionesAdicionales.map((item, i) => (
          <View key={`c-${i}`} style={pdfStyles.bulletRow}>
            <Text style={pdfStyles.bulletPoint}>•</Text>
            <Text style={pdfStyles.bulletText}>
              <Text style={{ fontWeight: "bold" }}>{item.bold}</Text>
              {item.text}
            </Text>
          </View>
        ))}

        {/* 4. MODIFICACIONES */}
        <Text style={pdfStyles.sectionTitle}>4. MODIFICACIÓN DE SERVICIO</Text>

        <Text style={pdfStyles.paragraph}>
          Cualquier modificación en el alcance o duración del servicio debe ser acordada por ambas partes con al menos 96 horas de antelación.
        </Text>

        {/* 5. OTRAS CONDICIONES */}
        <Text style={pdfStyles.sectionTitle}>5. OTRAS CONDICIONES</Text>

        <Text style={pdfStyles.paragraph}>
          La alimentación del cuidador será proporcionada por el cliente. El cliente se compromete a brindar las comidas necesarias durante el período de prestación del servicio.
        </Text>

        <Text style={pdfStyles.paragraph}>
          En caso de no poder hacerlo, podrá solicitar a la empresa la gestión de un servicio de alimentación básica. Para ello, deberá requerir previamente el presupuesto formal correspondiente, el cual deberá ser aprobado por el cliente antes de su implementación. Los costos asociados a este servicio serán incluidos en la facturación correspondiente al cuidado domiciliario.
        </Text>
         <Text style={[pdfStyles.paragraph, { marginTop: 12 }]}>
          En aquellos casos en que el servicio se inicie en un sanatorio u otro establecimiento asistencial y, posteriormente, el usuario sea trasladado a su domicilio, deberá procederse —con carácter previo a la continuidad del servicio— a una nueva evaluación por parte del Departamento Operativo.
        </Text>

        <Text style={pdfStyles.paragraph}>
          Dicha evaluación tendrá por objeto verificar la condición clínica actual del paciente al momento del alta, así como determinar si los cuidados inicialmente contratados continúan siendo adecuados o si corresponde la prestación de servicios de mayor complejidad o especialización.
        </Text>

        <Text style={pdfStyles.paragraph}>
          En virtud de dicha revisión, la empresa podrá modificar, ampliar o ajustar el alcance del servicio requerido en el domicilio. En caso de que la evaluación determine la necesidad de cuidados adicionales o especializados, se aplicará la tarifa vigente correspondiente al nuevo nivel de atención, lo cual será debidamente informado al cliente para su conocimiento y aceptación previa a la continuidad del servicio.
        </Text>

        <Text style={pdfStyles.firmaText}>
          Nombre y firma del cliente: ________________________________
        </Text>

      </Page>

     
      {/* Presupuesto en páginas adicionales */}
      <PresupuestoPDF {...props} />

    </Document>
  );
}
